







































import Popper from "popper.js";
import { Vue, Component, Prop } from "vue-property-decorator";
import { Action, namespace, State } from "vuex-class";
import { Mode } from "@/types";
import { Modes } from "@/modes";

const Auth = namespace("auth");

@Component({})
export default class ModeButton extends Vue {
  private popper: Popper | null = null;

  @Prop()
  private document!: string;

  @State("mode")
  private mode!: Mode;

  @Auth.State("groups")
  private groups!: string[];

  @Action("updateMode")
  private update!: (mode: Mode) => void;

  @Action("clear")
  private clear!: (payload: { keepRaw?: boolean }) => void;

  @Action("matches/update")
  analyse!: () => void;

  @Action("evidences/update")
  encode!: () => void;

  @Action("verify/update")
  verify!: () => void;

  get modes() {
    return Object.values(Modes).filter(mode => mode.check(this.groups));
  }

  process(text: string) {
    if (this.mode.key === Modes.Analysis.key || this.mode.key === Modes.Timeline.key) {
      this.analyse();
    }
    if (this.mode.key === Modes.Encode.key) {
      this.encode();
    }
    if (this.mode.key === Modes.Verify.key) {
      this.verify();
    }
  }

  show() {
    this.popper = new Popper(
      this.$refs.button as HTMLElement,
      this.$refs.popover as HTMLElement,
      {
        placement: "bottom"
      }
    );

    window.setTimeout(() => {
      document.addEventListener("click", this.onClickOutsidePopover, true);
    }, 100);

    this.$nextTick(() => {
      if (this.popper) this.popper.update();
    });
  }

  hide() {
    if (this.popper) {
      this.popper.destroy();
      this.popper = null;
    }

    document.removeEventListener("click", this.onClickOutsidePopover, true);
  }

  onClickOutsidePopover(e: Event) {
    const element = (this.$refs.popover as Vue).$el || this.$refs.popover;

    if (
      (element as HTMLElement).offsetParent &&
      e.target &&
      !element.contains(e.target as Element)
    ) {
      this.hide();
    }
  }
}
